/**
 * Web: hidden file input — native module is unavailable in webpack build.
 */

type Asset = {
  uri: string;
  width?: number;
  height?: number;
  type?: string;
  fileSize?: number;
};

type ImagePickerResponse = {
  didCancel: boolean;
  errorCode?: string;
  assets?: Asset[];
};

type PickOptions = {
  mediaType?: string;
  quality?: number;
  selectionLimit?: number;
};

function pickWithInput(opts: { capture?: boolean | string }): Promise<ImagePickerResponse> {
  return new Promise((resolve) => {
    if (typeof document === 'undefined') {
      resolve({ didCancel: true });
      return;
    }

    const input = document.createElement('input');
    input.type = 'file';
    input.accept = opts.capture ? 'image/*' : 'image/*';
    input.multiple = false;
    input.style.position = 'fixed';
    input.style.left = '-9999px';
    if (opts.capture) {
      input.setAttribute('capture', typeof opts.capture === 'string' ? opts.capture : 'environment');
    }

    const finish = (out: ImagePickerResponse) => {
      input.remove();
      resolve(out);
    };

    input.addEventListener('change', () => {
      const file = input.files?.[0];
      if (!file) {
        finish({ didCancel: true });
        return;
      }
      const uri = URL.createObjectURL(file);
      const img = new Image();
      img.onload = () => {
        finish({
          didCancel: false,
          assets: [
            {
              uri,
              width: img.naturalWidth || img.width,
              height: img.naturalHeight || img.height,
              type: file.type && file.type.length > 0 ? file.type : 'image/jpeg',
              fileSize: file.size,
            },
          ],
        });
      };
      img.onerror = () => {
        URL.revokeObjectURL(uri);
        finish({ didCancel: true });
      };
      img.src = uri;
    });

    document.body.appendChild(input);
    // Some browsers only fire change after explicit user gesture; click() is ok here.
    input.click();
  });
}

export function launchImageLibrary(_options?: PickOptions): Promise<ImagePickerResponse> {
  return pickWithInput({});
}

export function launchCamera(_options?: PickOptions): Promise<ImagePickerResponse> {
  return pickWithInput({ capture: 'environment' });
}
